import { render, staticRenderFns } from "./ModalOsVencidasArmazem.vue?vue&type=template&id=21e85922&scoped=true&"
import script from "./ModalOsVencidasArmazem.vue?vue&type=script&lang=js&"
export * from "./ModalOsVencidasArmazem.vue?vue&type=script&lang=js&"
import style0 from "./ModalOsVencidasArmazem.vue?vue&type=style&index=0&id=21e85922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e85922",
  null
  
)

export default component.exports